<template>
	<b-modal
		id="location-entry-carbon-dialog"
		v-model="isOpen"
		header-class="header-class-modal-doc-package"
		:title="FormMSG(122, 'Location energy consumption')"
		size="xl"
		no-close-on-backdrop
		no-close-on-esc
		:cancel-title="FormMSG(121, 'Cancel')"
		ok-variant="primary"
		:ok-disabled="loadingForSubmit"
		:cancel-disabled="loadingForSubmit"
		cancel-variant="custom-outline-gray"
		@ok.prevent="handleOk"
		@cancel="emitEventClose"
		@hidden="emitEventClose"
		modal-class="mui-animation"
		:fade="false"
	>
		<div>
			<b-row>
				<b-col>
					<b-alert :show="showError" variant="danger" dismissible @dismissed="handleClickDismissed">
						{{ error }}
					</b-alert>
				</b-col>
			</b-row>
			<perfect-scrollbar ref="containerLocationEntryCarbon" class="container-location-entry-carbon">
				<div id="containerLocationEntryCarbon">
					<div v-for="(item, index) in carbonList" :key="index">
						<div class="d-flex justify-content-around" :id="`item_${index}`">
							<div style="width: 92%">
								<fieldset class="my-0 py-0 pb-0" :class="`${$screen.width <= 576 ? '' : 'scheduler-border'}`" tyle="height: 100%">
									<legend
										v-if="$screen.width > 576"
										:class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`"
										class="text-color-rhapsody-in-blue-2"
									>
										{{ FormMSG(653, 'Entry') + ' ' + (index + 1) }}
									</legend>
									<div class="pt-3 pb-3">
										<b-row>
											<b-col sm="12" md="3" lg="3" xl="3">
												<b-form-group :label="FormMSG(654, 'Source')">
													<b-form-input :value="entityLabel" class="bg-color-grams-hair" disabled />
												</b-form-group>
											</b-col>
											<b-col sm="12" md="3" lg="3" xl="3">
												<b-form-group :label="FormMSG(810, 'Date')">
													<v-date-picker
														:value="item.strDate"
														:locale="lang"
														:masks="{ input: 'DD/MM/YYYY' }"
														@input="handleInputCarbonDateTime($event, index)"
													>
														<template v-slot="{ inputValue, togglePopover }">
															<b-input-group>
																<b-form-input :value="inputValue" readonly class="bg-white" @click="togglePopover" />
																<b-input-group-append>
																	<b-input-group-text class="cursor-pointer" @click="togglePopover">
																		<component :is="getLucideIcon('Calendar')" color="#06263E" :size="16" />
																	</b-input-group-text>
																</b-input-group-append>
															</b-input-group>
														</template>
													</v-date-picker>
												</b-form-group>
											</b-col>
										</b-row>
										<co-two-clap
											:key="`coTwoClapLocation_${index}`"
											:parent-id="+item.entityId"
											:entity-type="1"
											:for-create="false"
											:external-carbon-data="item"
											hide-btn-reviewed
											disable-carbon-type-selector
											hide-co-two-category-selector
											@co-two-clap:change="handleCoTwoClapChange($event, index)"
										/>
									</div>
								</fieldset>
							</div>
							<div class="d-flex justify-content-center">
								<button type="button" class="btn-transparent text-color-burning-tomato" @click="handleClickRemoveEntry(index)">
									<component :is="getLucideIcon('MinusCircle')" :size="20" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>

			<b-row>
				<b-col>
					<div
						class="d-flex mt-2"
						:class="{ 'justify-content-end': carbonToDelete.length === 0, 'justify-content-between': carbonToDelete.length > 0 }"
					>
						<div v-if="carbonToDelete.length > 0" class="d-flex">
							<div>
								<button
									class="btn-transparent text-color-blue-streak"
									v-b-tooltip.hover.righttop="
										FormMSG(427, 'The number displayed here is the number of entries you have saved and wish to delete.')
									"
								>
									<component :is="getLucideIcon('Info')" :size="16" />
								</button>
							</div>
							<div class="fs-14 fw-700 text-color-rhapsody-in-blue">
								{{ FormMSG(485, 'Entry to delete :') }}
							</div>
							<div class="fs-14 fw-700 text-color-negative">
								{{ carbonToDelete.length }}
							</div>
						</div>
						<button type="button" class="btn-transparent text-color-rhapsody-in-blue" @click="handleClickAddEntry">
							<div class="d-flex">
								<div class="mr-2">
									<component :is="getLucideIcon('PlusCircle')" :size="20" color="#47C7BF" />
								</div>
								<div class="fs-14 fw-700">
									{{ FormMSG(45, 'Add entry') }}
								</div>
							</div>
						</button>
					</div>
				</b-col>
			</b-row>
		</div>

		<template #modal-ok>
			<div>
				<b-spinner v-if="loadingForSubmit" small />
				{{ FormMSG(135, 'Save') }}
			</div>
		</template>
	</b-modal>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import coTwoClap from './CoTwoClap.vue';
import _ from 'lodash';
import { INIT_DATA_CARBON } from '@/shared/constants';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { delCarbon, addUpdSliceCarbon } from '@/cruds/carbon.crud';

export default {
	name: 'LocationEntryCarbonDialog',

	mixins: [languageMessages, globalMixin],

	props: {
		open: { type: Boolean, default: false, required: false },
		location: { type: Object, required: true },
		isPremise: { type: Boolean, default: false, required: false },
		carbons: { type: Array, default: () => [], required: false }
	},

	components: {
		'v-date-picker': DatePicker,
		coTwoClap,
		PerfectScrollbar
	},

	data() {
		return {
			carbonList: [],
			carbonToDelete: [],

			loadingForSubmit: false,
			showError: false,
			error: ''
		};
	},

	watch: {
		carbons: {
			handler(newVal) {
				if (newVal.length > 0) {
					this.carbonList = [];
					for (let i = 0; i < newVal.length; i++) {
						this.carbonList.push({
							..._.omit(newVal[i], [
								'id',
								'projectId',
								'createdAt',
								'updatedAt',
								'supplier',
								'user',
								'department',
								'function',
								'carbonValues',
								'carbonTemplate'
							]),
							strDate: new Date(newVal[i].strDate),
							endDate: new Date(newVal[i].endDate),
							carbonId: +newVal[i].id,
							fromDatabase: true
						});
					}
				}
			},
			immediate: true,
			deep: true
		}
	},

	computed: {
		isOpen: {
			get() {
				return this.open;
			},
			set(val) {
				return val;
			}
		},
		entityLabel() {
			return !this.isPremise ? this.FormMSG(658, 'Location') : this.FormMSG(659, 'Premise');
		}
	},

	methods: {
		handleClickDismissed() {
			this.showError = false;
			this.error = '';
		},
		async handleOk() {
			try {
				this.loadingForSubmit = true;

				if (this.carbonToDelete.length > 0) {
					await delCarbon(this.carbonToDelete);
				}

				const result = await addUpdSliceCarbon(this.carbonList, this.isPremise ? 10 : 5, +this.location.id);

				this.emitEventSuccess(result);
				this.createToastForMobile(this.FormMSG(451, 'Success'), this.FormMSG(452, 'Data added and updated successfully!'));

				this.loadingForSubmit = false;
				this.emitEventClose();
			} catch (e) {
				this.loadingForSubmit = false;
				this.error = this.resolveGqlError(e);
				this.showError = true;
			}
		},
		async handleClickRemoveEntry(index) {
			if (this.carbonList[index].fromDatabase === true) {
				this.carbonToDelete.push(+this.carbonList[index].carbonId);
			}

			this.carbonList.splice(index, 1);
		},
		handleCoTwoClapChange({ carbonData }, index) {
			this.carbonList[index] = {
				..._.omit(carbonData, ['strDate', 'endDate', 'entityType', 'entityId', 'carbonId']),
				strDate: this.carbonList[index].strDate,
				endDate: this.carbonList[index].endDate,
				entityType: this.carbonList[index].entityType,
				entityId: this.carbonList[index].entityId,
				carbonId: this.carbonList[index].carbonId,
				fromDatabase: this.carbonList[index].fromDatabase
			};
		},
		handleInputCarbonDateTime(payload, index) {
			this.carbonList[index].strDate = payload;
			this.carbonList[index].endDate = payload;
		},
		handleClickAddEntry() {
			let newCarbon = _.cloneDeep(INIT_DATA_CARBON);
			newCarbon.entityId = +this.location.id;
			newCarbon.entityType = !this.isPremise ? 5 : 10;
			newCarbon.strDate = new Date(this.location.getInDate);
			newCarbon.endDate = new Date(this.location.getInDate);
			newCarbon.entityId = +this.location.id;
			newCarbon.coTwoCategory = !this.isPremise ? 1 : 15;
			newCarbon.generatorFuelType = 0;
			this.carbonList.push({
				...newCarbon,
				fromDatabase: false
			});

			this.$nextTick(() => {
				setTimeout(() => {
					const container = document.getElementById(`item_${this.carbonList.length - 1}`);

					this.$refs.containerLocationEntryCarbon.$el.scrollTo(0, this.$refs.containerLocationEntryCarbon.$el.scrollHeight);

					container.scrollIntoView({ behavior: 'smooth' });
				}, 250);
			});
		},
		emitEventSuccess(carbons) {
			this.$emit('location-entry-carbon:submit-success', { carbons });
		},
		emitEventClose() {
			this.carbonToDelete = [];
			this.carbonList = [];

			this.$emit('location-entry-carbon:close');
		}
	}
};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
